import AgreeToPolicy from "@/components/login-register/agree-to-policy";
import AccountRegister from "@/components/login-register/register/account-register";

export default function Register() {
    return <>
        <AccountRegister/>
        <AgreeToPolicy/>
    </>;
}
